import $ from 'jquery'
import async from 'async'
import _ from 'lodash'
import cityChoser from '../../../lib/common/cityChoser'

let _p = window.xwCommon,
    _this = {
    	title:"建档",
    	name:"createWin",
    	loadBaseNodes(vm){
	        let func = (callback,reject) => {
	          vm.$bus.emit("loading",true)
	          async.waterfall([
	            ( next ) => {
	              cityChoser.getProvinceList(vm).then((data) => next(null,data),(err) => next(err))
	            },
	            ( provList, next ) => {
	              vm.cities.list = provList //.map(( item ) => {
	              //   return $.extend({cityList:[]},item)
	              // })
	              
	              next(null)
                },
                (next) => {
                    let u = _p.getApiUrl("depart/getStoreByArea");
                    $.post(u).then((res) => {
                        let status = parseInt(res.status)
                        if (status !== 200) {
                            switch (status) {
                                default: if (_p.checkAjaxStatus(vm, res, vm.title)) break;
                                //vm.$alert(json.msg,vm.pageTitle);
                                next(json.msg)
                                break;
                            }
                            return;
                        } else {
                            let aData=res.data||[];
                            aData.map((value) => {
                                value.name = value.province;
                                value.children.map((value) => {
                                    value.name = value.city
                                    value.children.map((value) => {
                                        value.name = value.depart_name
                                    })
                                })
                            })
                            vm.StoreByArea = aData
                            next(null)
                        }
                    })
                },
                ( next ) => {
                    let u = _p.getApiUrl('order/orderType');
                    $.post(u,{type:'ph'}).then((res) => {
                        let status = parseInt(res.status)
                        if (status !== 200) {
                            switch (status) {
                                default: if (_p.checkAjaxStatus(vm, res, vm.title)) break;
                                //vm.$alert(json.msg,vm.pageTitle);
                                next(json.msg)
                                break;
                            }
                            return;
                        } else {
                            vm.orderType = res.data;
                            next(null)
                        }
                    })
                    //vm.orderType = 
                },
                ( next ) => {
                    let user = _p.getStoredProp("staff/query"), 
                        depart_type_id = _p.getStoredProp("staff/currentQuery").depart_type_id,
                        data = {province_id:user.province_id, city_id:user.city_id,product_type:2},
                        u = _p.getApiUrl("product/search")
                    $.post(u,data,(json) => {
                        let status = parseInt(json.status)
                        if(200 !== status){
                            switch(status){
                                default: 
                                  if(_p.checkAjaxStatus(vm,json,_this.title)) break;
                                  else vm.$alert(json.msg)
                                  break;
                            }
                            return;
                        }else{
                            let gData = _.groupBy(json.data,(v) => {return v.product_tpl_id}), pData = []
                            gData = _.forEach(gData,(childrens, k) =>{
                                let tpl = childrens[0], product_id = tpl.product_tpl_id, product_name = tpl.name
                                if(tpl.product_type == 2)pData.push({product_name, product_id, childrens})
                            })
                            vm.productSearchItem = pData
                            _.forEach(vm.productSearchItem,(childrens,k) =>{
                                _.forEach(childrens.childrens,(j)=>{
                                    if(j.product_name=="小微速贷D11_OLD"){
                                        j.disabled = true
                                    }
                                })
                            })
                            if(depart_type_id == 2){
                                _this.getCityList(vm, user.province_id,2)
                                _this.getDistrictList(vm,[user.province_id,user.city_id])
                            }
                            next(null)
                        }
                    }).then((data)=>{
                        if(depart_type_id == 2) vm.$set(vm.fileForm,'user_cityId',[user.province_id,user.city_id])
                    })
                }
	          ],(err) => {
                vm.$bus.emit("loading",false)
	            if(err) return reject(err)
	            else return callback()
	          })
	        }
	        return new Promise(func)
        },
        initWin(vm){
            _this.loadBaseNodes(vm).then(() => {
                vm.fileForm = _this.getEmptyForm()
                vm.showDialog = true
            })
        },
        getEmptyForm(){
            return {
                order_type:1, 
            }
        },
        changeProductSearch(vm){
        	let u = _p.getApiUrl("product/search"),cityId = cityChoser.parseCityId(vm.fileForm.cityId),
        		business_type_id = vm.fileForm.business_type_id, pay_type_id = vm.fileForm.pay_type_id,
        		data = $.extend({business_type_id, pay_type_id},cityId)
        	if(!(cityId.city_id%1e4)) delete data.city_id
	        $.post(u,data,(json) => {
                let status = parseInt(json.status)
                if(200 !== status){
                  	switch(status){
                        default: 
                          if(_p.checkAjaxStatus(vm,json,_this.title)) break;
                          else vm.$alert(json.msg)
                          break;
                    }
                    return;
                }else{
                  	vm.productSearchItem = json.data
                  	vm.$set(vm.fileForm,"product_id","")
                }
	        })
        },
        submit(vm){
        	let func = (callback,reject) => {
        		let u = _p.getApiUrl("order/newOrder"),
        			obj = vm.fileForm,
        			data = _p.cleanProp(obj,["cityId","business_type_id","pay_type_id","user_cityId","product_id"])
                if(obj.product_id.length > 1){
                    data.product_id = obj.product_id[1]
                }
                vm.loading = true;
        		data.birthday = _p.date("yyyy-MM-dd",data.birthday)
                data.resident_address = cityChoser.toCityName(vm,obj.user_cityId)+data.resident_address
                data.product_type = 2;
                data.car_load_type = '';
        		$.post(u,data,(json) => {
        			let status = parseInt(json.status)
	                if(200 !== status){
	                  	switch(status){
	                        default: 
		                        if(_p.checkAjaxStatus(vm,json,_this.title)) break;
		                        else reject(new Error(json.msg))
		                        break;
	                    }
	                    return;
	                }else{
                        vm.loading = false
                        vm.$notify({title:_this.title,message:json.msg});
                        vm.$bus.emit('reloadPuHuiTodo')
	                	callback(json.data)
	                }
        		},"json")
        	}
        	
        	return new Promise(func)
        },
        getCustomer(vm,car_num){
            let url = _p.getApiUrl("order/getSynOrderInfo")
            $.post(url,{car_num},(json) => {
                let status = parseInt(json.status)
                if(200 != status){
                  switch(status){
                    default: 
                      if(_p.checkAjaxStatus(vm,json,_this.title)) break;
                      else vm.$alert(json.msg,_this.title);
                      break;
                  }
                  return;
                }else{
                    vm.fileForm.pay_type = String(json.data.pay_type)
                    vm.fileForm.mortgage_company = json.data.mortgage_company
                    vm.fileForm.apply_purpose = json.data.apply_purpose
                    vm.fileForm.apply_price = String(json.data.apply_price)
                    vm.fileForm.car_load_type = json.data.car_load_type
                    _this.getBasicInfo(vm,json.data.order_id)
                }
            })
        },
        getBasicInfo(vm,order_id){
            let url = _p.getApiUrl("order/getCustomerInfo")
            $.post(url,{order_id},(json) => {
                var json = eval("("+json+")")
                let status = parseInt(json.status)
                if(200 != status){
                  switch(status){
                    default: 
                      if(_p.checkAjaxStatus(vm,json,_this.title)) break;
                      else vm.$alert(json.msg,_this.title);
                      break;
                  }
                  return;
                }else{
                    vm.fileForm.name=json.data.name
                    vm.fileForm.phone=json.data.phone
                    vm.fileForm.idcard=json.data.idcard
                    vm.fileForm.birthday=new Date(json.data.birthday)
                    vm.fileForm.sex=json.data.sex
                    let addr = cityChoser.parseAddr(vm, json.data["resident_address"])
                    vm.fileForm.resident_address = addr.addr
                    vm.fileForm.user_cityId = addr.cityId || []
                }
            })
        },
        getApplyPrice(vm,val){
            let [product_tpl_id,product_id,SearchItem]=val;
             SearchItem=_.find(vm.productSearchItem,(Pitem)=>{
                  return Pitem.product_id == product_tpl_id;
            })
            if(!SearchItem)return;
            _.forEach(SearchItem.childrens,(Sitem)=>{
                if(Sitem.product_id == product_id){
                    let price = Sitem.ph_apply_price + '' || "0";
                    vm.$set(vm.fileForm,"apply_price",price);
                    return;
                }
            })
        },
        rules:{
            "product_id":[
                { type:'array', len:2, required: true, message: '请选择产品', trigger: 'change' }
            ],
            "order_type":[
                { type:'integer', required: true, message: '请选择业务方式', trigger: 'change' }
            ],
            "car_load_type":[
                { type:'integer', required: true, message: '请选择估价方式', trigger: 'change' }
            ],
            "pay_type":[
                { required: true, message: '请选择车辆按揭状态', trigger: 'blur' }
            ],
            "apply_price":[
                { required: true, message: '请输入申请金额', trigger: 'blur' },
                { min: 1, max: 32, message: '申请金额格式错误', trigger: 'blur' }
            ],
            "apply_purpose":[
                { required: true, message: '请选择申请用途', trigger: 'change'}
            ],
            "name":[
                { required: true, message: '请输入客户姓名', trigger: 'blur' },
                { min: 2, max: 32, message: '客户姓名格式错误', trigger: 'blur' }
            ],
            "phone":[
                { required: true, message: '请输入手机号码', trigger: 'blur' },
                { min: 7, max: 13, message: '手机号码格式错误', trigger: 'blur' },
                { validator: _p.validator.phone, message: '手机号码格式错误', trigger: 'blur' }
            ],
            "car_num":[
                { required: true, message: '请输入车牌号', trigger: 'blur' },
                { validator: _p.validator.carNum, message: '车牌号格式错误(不能存在空格符)', trigger: 'blur' }
            ],
            "idcard":[
                { required: true, message: '请输入身份证号', trigger: 'blur' },
                { len: 18, message: '身份证号格式错误', trigger: 'blur' },
                { validator: _p.validator.idcard, message: '无效的身份证号', trigger: 'blur'}
            ],
            "birthday":[
                { type:'date', required: true, message: '请选择出生年月', trigger: 'change' }
            ],
            "sex":[
                { type:'integer', required: true, message: '请选择性别', trigger: 'change' }
            ],
            "resident_address":[
                { required: true, message: '请输入户口所在地', trigger: 'blur' },
                { min: 6, message: '户口所在地格式错误', trigger: 'blur' }
            ],
            "idcard_validity":[
                { required: true, message: '请输入身份证有效期', trigger: 'blur' }
            ]

        },
      	getCityList:cityChoser.getCityList,
      	getDistrictList:cityChoser.getDistrictList
    }
export default _this


// WEBPACK FOOTER //
// ./src/financialSystem/js/form/createFile.js